import { api } from 'utility';
import {
  getImprestCardInfo,
  getShebaServiceUrl,
  getCardServiceUrl,
  getBusinessUrl,
  getFinancialTransferUrl,
  getToggleAutoSettelmentUrl,
  getGuildServiceUrl,
  getShebaGuildUrl,
  getDeleteOrEditGuildUrl,
  getRequestSettelmentFromGuildUrl,
  getPaymentServiceUrl,
  getCreateUniqueDepositUrl,
  getPaginateReportSaleInvoiceUrl,
  getExportPaginateReportPurchaseInvoiceUrl,
  getCarTableListUrl
} from 'URLs';
class DetailAccountsServices {
  async createAccount(params) {
    return api.post(getGuildServiceUrl(), {
      ...params,
    });
  }

  async credit() {
    return api.get(getImprestCardInfo()).then((res) => res.data);
  }

  async charge(params) {
    return api.get(getPaymentServiceUrl(), { params }).then((res) => res.data);
  }

  async getShebaAccount(params) {
    return api.get(getShebaGuildUrl(), { params }).then((res) => res.data);
  }

  async moneyTransfer(param) {
    return api.post(getFinancialTransferUrl(), {
      ...param,
    });
  }

  async reportFactorsDebtor(param, dataParams) {
    return api.post(getPaginateReportSaleInvoiceUrl(param.size, param.page), {
      ...dataParams,
    });
  }
  async checkCartable(param) {
    return api.post(getCarTableListUrl(), {
      ...param,
    });
  }
  async reportFactorsCreditor(param, dataParams) {
    return api.post(getExportPaginateReportPurchaseInvoiceUrl(param.size, param.page), {
      ...dataParams,
    });
  }

  async getSheba(params) {
    return api.get(getShebaServiceUrl(), { params }).then((res) => res.data);
  }

  async deleteGuild(code) {
    return api.delete(getDeleteOrEditGuildUrl(code), {}).then((res) => res.data);
  }

  async getCard(params) {
    return api.get(getCardServiceUrl(), { params }).then((res) => res.data);
  }

  async autoSettlement(param) {
    return api.post(getToggleAutoSettelmentUrl(), {
      ...param,
    });
  }

  async deleteSettlement(param) {
    return api.delete(getToggleAutoSettelmentUrl(), { params: { ...param } });
  }

  async settlement(param) {
    return api.post(getRequestSettelmentFromGuildUrl(), {
      ...param,
    });
  }

  async getBusiness() {
    return api.get(getBusinessUrl());
  }

  async generateCreditInvoicePaymentNumber(params) {
    return api.get(getCreateUniqueDepositUrl(), { params }).then((res) => res.data);
  }
}

const detailAccountsServices = new DetailAccountsServices();
export default detailAccountsServices;
